export default {
  title: {
    en: '{brandName} reviews',
  },
}
